// extracted by mini-css-extract-plugin
export default {"layout_dashboard_default":"dashboard-default_layout_dashboard_default__BgwYn"};